import ScrollReveal from 'scrollreveal';

export default {
	init: function(){
		window.sr = ScrollReveal({ reset:false });

		sr.reveal('.timeline-item', {
			duration: 750,
			scale: 1,
			easing: 'linear',
			afterReveal: this.addActive,
			viewFactor: 0.7,
		});

		sr.reveal('.card', {
			duration: 300,
			scale: 0.9,
			easing: 'cubic-bezier(.17,.47,.36,1.47)',
			viewFactor: 0.7,
			delay: 850
		}, 50);

		sr.reveal('.in-right', {
			scale: 1,
			easing: 'linear',
			duration: 600,
			origin: 'left',
			viewFactor: 0.7,
		});

		sr.reveal('.in-up', {
			scale: 1,
			easing: 'linear',
			duration: 450,
			viewFactor: 0.7,
		});

		sr.reveal('.in-center-delay', {
			duration: 650,
			distance: 0,
			scale: 0.9,
			easing: 'cubic-bezier(.17,.47,.36,1.47)',
			viewFactor: 0.7,
			delay: 300
		}, 65);

	},
	addActive: function(domEL){
		domEL.classList.add('active');
	}
};
